import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

export class SalesCodeComboBox extends Component {

    static displayName = SalesCodeComboBox.name;

    constructor(props) {

        super(props);


        this.state = { items: props.items, selectedValue: props.selectedValue };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(e) {
        var handle = this.props.onSelectValueChanged;
        if (handle) {
            const selectedValue = e.target.value;
            this.setState({ selectedValue: selectedValue });

            handle(selectedValue)

        }

    }

    render() {
        
        var clsNames = "bg-right p-0 text-center border-gray-200 focus:ring-indigo-500 focus:border-indigo-500 rounded-md w-full ";
        if (this.props.classnames) {
            clsNames += this.props.classnames;
        }

        const items = this.props.items;
        if (!items || items.length <= 0) {
            return <select className={clsNames} {...this.props}>
                <FormattedMessage id={this.props.isOtherPlatform ? "UnconfiguredTingzhanSalesCode" :"SelectDevliverCode"} >
               {/* <FormattedMessage id="SelectDevliverCode" >*/}
                    {text => <option value="-1">{text}</option>}
                </FormattedMessage>                    
            </select>;
        }

        return (

            <select className={clsNames} {...this.props} value={this.state.selectedValue} onChange={this.handleChange}>

                {items.map(item => <option value={item}>{item}</option>)}

            </select>

        );

    }

}
